import { useTranslation } from 'react-i18next'

import { useTheme } from 'styled-components'

import { Alert, DeliveryMethod } from '@reveni-io/reveni-ui'

import DeliveryMethodsSkeleton from './DeliveryMethodsSkeleton/DeliveryMethodsSkeleton'

const DeliveryMethods = ({ deliveryMethods, regions, loading }) => {
  const theme = useTheme()
  const { t } = useTranslation()

  if (loading) return <DeliveryMethodsSkeleton />

  if (!deliveryMethods?.length) {
    return <Alert type="info">{t('Este criterio aún no está asociado a ningún método de devolución.')}</Alert>
  }

  return (
    <>
      {deliveryMethods.map(method => (
        <DeliveryMethod
          key={method.id}
          data={method}
          regions={regions}
          isEditable={false}
          showSwitch={false}
          customBackgroundColor={theme.colors.background.secondary}
          containerPadding={`${theme.spacing.sp8} ${theme.spacing.sp16}`}
        />
      ))}
    </>
  )
}

export default DeliveryMethods
